export enum IB_TAB {
    ACCOUNTS = 'ACCOUNTS',
    CUSTOMERS = 'CUSTOMERS',
    SUPPLIERS = 'SUPPLIERS'
}